<script setup lang="ts">

  const props = defineProps<{
    icon: string;
    label: string;
    url: string;
    disabled: boolean;
    loading: boolean;
  }>();

  const handleClick = () => {
    window.location.href = props.url;
  }
</script>
<template>
  <a
    v-if="url"
    class="login-option"
    :href="disabled ? 'javascript:void(0);' : url"
    :title="props.label"
    :class="{ 'disabled': props.disabled, 'loading': props.loading }"
    @click="handleClick"
  >
    <div v-html="props.icon"></div>
    <div class="login-option__label">
      {{ props.label }}
      <p v-if="loading">
        loading...
      </p>
    </div>
  </a>
</template>

<style lang="scss" scoped>
  .login-option {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px 16px;
    border: 1px solid var(--alc-base-200);
    border-radius: 8px;
    background: var(--alc-white);
    cursor: pointer;
    gap: 4px;

    &.disabled {
      pointer-events: none;
      cursor: not-allowed;
      background: var(--alc-base-200);
      opacity: 0.3;
      border: 1px solid var(--alc-base-800);

      &.loading {
        opacity: 0.7;
      }
    }

    &:hover {
      background: var(--alc-aqua-100);
    }

    &__icon {
      width: 28px;
      height: 28px;
    }

    &__label {
      color: var(--alc-base-600);
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 14px;

      p {
        line-height: 20px;
      }
    }
  }
</style>
